import React from 'react';
import { View, Text, Platform } from 'react-native';
import { themeSelector } from '@reduxLocal/selectors/themeSelector';
import type { UIComponentContract } from '../../types/componentContract';

// Conditionally import charts only on web
let WebBarChart: any = null;
if (Platform.OS === 'web') {
  try {
    const chartUtils = require('@utils/chartUtils/createChart');
    WebBarChart = chartUtils.BarChart;
  } catch (error) {
    console.warn('BarChart not available for web');
  }
}

export const uiContract: UIComponentContract = {
  id: "chart.bar",
  accepts: {
    capability: "display_chart",
    shape: {
      seriesData: "array",
      seriesName: "string?",
      categories: "array?",
      height: "number?",
      colors: "array?"
    },
    required: ["seriesData"],
    optional: ["seriesName", "categories", "height", "colors"]
  },
  renders: "chart",
  priority: 10,
  surface: "dashboard"
};

interface BarChartProps {
  data: {
    seriesData: Array<{ x: string; y: number }>;
    seriesName?: string;
    categories?: string[];
    height?: number;
    colors?: string[];
  };
}

export const BarChart: React.FC<BarChartProps> = ({ data }) => {
  const theme = themeSelector();
  const { seriesData, seriesName = "Data", categories = [], height = 310, colors = ['#487FFF'] } = data || {};

  if (Platform.OS === 'web' && WebBarChart) {
    return (
      <View style={{ height: height }}>
        <WebBarChart
          seriesData={seriesData}
          seriesName={seriesName}
          categories={categories}
          height={height}
          colors={colors}
        />
      </View>
    );
  }

  // Native fallback - could use react-native-chart-kit or similar
  return (
    <View style={{ height: height, justifyContent: 'center', alignItems: 'center', padding: 20 }}>
      <Text style={{ color: theme ? '#64748b' : '#94a3b8', fontSize: 14, textAlign: 'center' }}>
        Bar chart not available on this platform
      </Text>
    </View>
  );
};

// Attach contract to component
(BarChart as any).uiContract = uiContract;

export default BarChart;

